import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text/text';
import {ToggleSwitch, ToggleSwitchV2Size} from '@Components/toggle-switch-v2/toggle-switch';
import type {SuperUserToggleRowProps} from './super-user-toggle-row.types';
import styles from './super-user-toggle-row.module.scss';

export function SuperUserToggleRow({id, label, hint, isChecked, onChange}: SuperUserToggleRowProps): ReactElement {
  return (
    <div className={styles.toggleRow}>
      <div className={styles.toggleLabels}>
        <Text val={label} size={TextSize.SM} className={styles.toggleLabel} />
        {renderHint(hint)}
      </div>
      <ToggleSwitch id={id} isChecked={isChecked} onChange={onChange} size={ToggleSwitchV2Size.SMALL} elementTitle={label} />
    </div>
  );
}

function renderHint(hint: string | undefined): ReactElement | null {
  if (!hint) {
    return null;
  }

  return <Text val={hint} size={TextSize.XS} className={styles.toggleHint} />;
}
